import DocumentacaoMenu from './DocumentacaoMenu/DocumentacaoMenu'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import React from 'react'

export default function Documentacao() {
  return (
    <>
      <Route path="/main/documentacao/menu" render={() => auth(<DocumentacaoMenu />)} />
    </>
  )
}
